var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425 2544 c-59 -21 -110 -67 -139 -126 l-26 -52 0 -1086 0 -1086 26 -52 c30 -61 80 -105 143 -127 67 -23 1635 -23 1702 0 63 22 113 66 143 127 l26 52 0 1086 0 1086 -26 52 c-30 61 -80 105 -143 127 -65 22 -1644 21 -1706 -1z m1495 -494 l0 -130 -640 0 -640 0 0 130 0 130 640 0 640 0 0 -130z m-1020 -515 l0 -125 -130 0 -130 0 0 125 0 125 130 0 130 0 0 -125z m510 0 l0 -125 -130 0 -130 0 0 125 0 125 130 0 130 0 0 -125z m510 0 l0 -125 -130 0 -130 0 0 125 0 125 130 0 130 0 0 -125z m-1020 -510 l0 -125 -130 0 -130 0 0 125 0 125 130 0 130 0 0 -125z m510 0 l0 -125 -130 0 -130 0 0 125 0 125 130 0 130 0 0 -125z m510 -260 l0 -386 -127 3 -128 3 -3 383 -2 382 130 0 130 0 0 -385z m-1022 -252 l-3 -128 -127 -3 -128 -3 0 131 0 130 130 0 131 0 -3 -127z m510 0 l-3 -128 -125 0 -125 0 -3 128 -3 127 131 0 131 0 -3 -127z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculator_icon.988ee5fc35e10dca47c83e6ec7f9a9f8.svg";
export { ForwardRef as ReactComponent };